import * as React from "react";
import { formatDateTime, formatUTC } from "./format";

/** One time, in the session's display zone, with UTC on hover. */
export function When({ value, className }: { value: string | number | Date | undefined | null; className?: string }) {
  if (value === undefined || value === null || value === "") return <span className={className}>—</span>;
  return (
    <time className={className} dateTime={new Date(value).toISOString?.() ?? String(value)} title={formatUTC(value)}>
      {formatDateTime(value)}
    </time>
  );
}
